"use client";

import { LandingSiteTemplateGetDataMenuOutputApiModel } from "@/Apis/ClinicApi";
import { CenterOptions } from "@/Helpers/CenterOptions";
import { useResponsive } from "@/Hooks";
import { FC, useMemo } from "react";
import HeaderMenu from "./HeaderMenu";

interface HeaderNavProps {
  menus: LandingSiteTemplateGetDataMenuOutputApiModel[];
}

const HeaderNav: FC<HeaderNavProps> = ({ menus }) => {
  const { isMobile } = useResponsive();

  const menuItems = useMemo(() => {
    const targetLocationKey = isMobile
      ? CenterOptions.SiteTemplate.CenterSiteTemplateMenuLocationType.MobileMenu
          .key
      : CenterOptions.SiteTemplate.CenterSiteTemplateMenuLocationType.MainMenu
          .key;

    return menus
      .filter((menu) =>
        menu.CenterSiteTemplateMenuLocationTypeKeys.includes(targetLocationKey),
      )
      .flatMap((menu) => menu.Items);
  }, [isMobile, menus]);

  return (
    <ul className="main-nav">
      <HeaderMenu menuItems={menuItems} />
    </ul>
  );
};

export default HeaderNav;
